import { Customer } from '../models/customer';
import { Job } from '../models/job';
import { InviteeStatusEnum } from '../models/jobInviteeStatusEnum';

export type JobCounts = {
  booked: number;
  available: number;
  open: number;
  unavailable: number;
  requiredUsers: number;
  potentialInviteeCount: number;
};

export function getJobCounts(
  job?: Job,
  customer?: Customer,
  sharedPoolCustomers?: Customer[],
) {
  if (!job) {
    return {
      booked: 0,
      available: 0,
      open: 0,
      unavailable: 0,
      requiredUsers: 0,
      potentialInviteeCount: 0,
    };
  }
  const currentCustomerId = customer?._id;
  const sharedPoolCustomerIds = sharedPoolCustomers?.map(
    (customer) => customer._id,
  );
  return job.invitees.reduce(
    (counts: JobCounts, invitee) => {
      if (
        ((invitee.isSharedPooler ||
          sharedPoolCustomerIds?.includes(invitee.customer.id)) &&
          job.customer.id === currentCustomerId) ||
        invitee.customer.id === currentCustomerId ||
        (currentCustomerId &&
          job.ownerCustomerIds?.includes(currentCustomerId) &&
          invitee.status === InviteeStatusEnum.POSSIBLE_CANDIDATE) ||
        (currentCustomerId &&
          job.customer.id === currentCustomerId &&
          invitee.status === InviteeStatusEnum.POSSIBLE_CANDIDATE)
      ) {
        [
          InviteeStatusEnum.AVAILABLE,
          InviteeStatusEnum.POSSIBLE_CANDIDATE,
          InviteeStatusEnum.PARTIAL_AVAILABLE,
        ].includes(invitee.status)
          ? counts.available++
          : null;
        [
          InviteeStatusEnum.UNAVAILABLE,
          InviteeStatusEnum.DECLINED,
          InviteeStatusEnum.WORKING,
          InviteeStatusEnum.CANCELED,
        ].includes(invitee.status)
          ? counts.unavailable++
          : null;
        invitee.status == InviteeStatusEnum.OPEN ? counts.open++ : null;
        invitee.status == InviteeStatusEnum.BOOKED ? counts.booked++ : null;
      } else if (
        job.customer.id === currentCustomerId ||
        (currentCustomerId && job.ownerCustomerIds?.includes(currentCustomerId))
      ) {
        invitee.status == InviteeStatusEnum.BOOKED ? counts.booked++ : null;
      }
      return counts;
    },
    {
      booked: 0,
      available: 0,
      open: 0,
      unavailable: 0,
      requiredUsers: job.requiredUsers,
      potentialInviteeCount:
        job.customerInternalInformation?.[currentCustomerId || '']
          ?.potentialInviteeCount || 0,
    },
  );
}
